import axios from 'axios'

export default axios.create({
    // baseURL: "http://127.0.0.1:8000/api/"
    // baseURL: "https://admin.fms.optimalonline.co/api/"
    baseURL: "https://admin.fms.stageoptimal.co.za/api/"
})